import React from 'react';
import { SessionType } from '../types';

interface ProgressRingProps {
  progress: number; // 0-100 percentage
  sessionType: SessionType;
  size?: number;
  strokeWidth?: number;
}

const ProgressRing: React.FC<ProgressRingProps> = ({ 
  progress, 
  sessionType, 
  size = 300, 
  strokeWidth = 8 
}) => {
  const radius = (size - strokeWidth) / 2;
  const circumference = radius * 2 * Math.PI;
  const offset = circumference - (progress / 100) * circumference;

  // Get colors based on session type
  const getColors = () => {
    switch (sessionType) {
      case SessionType.WORK:
        return {
          stroke: '#6DAA88', // primary
          background: '#A7D7BF40' // accent with opacity
        };
      case SessionType.SHORT_BREAK:
        return {
          stroke: '#A7D7BF', // accent
          background: '#E1EDE4' // surface
        };
      case SessionType.LONG_BREAK:
        return {
          stroke: '#6DAA88', // primary
          background: '#A7D7BF20' // accent with lower opacity
        };
    }
  };

  const colors = getColors();

  return (
    <div className="relative flex items-center justify-center">
      <svg
        width={size}
        height={size}
        className="transform -rotate-90 transition-all duration-300"
      >
        {/* Background circle */}
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke={colors.background}
          strokeWidth={strokeWidth}
          fill="transparent"
          className="transition-colors duration-300"
        />
        
        {/* Progress circle */}
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke={colors.stroke}
          strokeWidth={strokeWidth}
          fill="transparent"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap="round"
          className="transition-all duration-500 ease-out"
          style={{
            filter: 'drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1))'
          }}
        />
      </svg>
      

    </div>
  );
};

export default ProgressRing; 